import { Trans } from '@lingui/macro'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Slider,
  TextField,
  Typography
} from '@mui/material'
import { FormTopLabel } from 'app/views/common-components/forms/FormTopLabel'
import React from 'react'
import { INDEX_OF_DONE } from './ActionPlan'
import { moveToColumn } from 'app/redux/actions/ActionPlanActions'
import { useDispatch } from 'react-redux'
import { DialogTitleWithIconClose } from 'app/views/common-components/DialogTitleWithIconClose'

const ActionDoneDialog = props => {
  const [actual, setActual] = React.useState(props.action.actualOutcome || '')
  const [success, setSuccess] = React.useState(props.action.success || 1)
  const [successTouched, setSuccessTouched] = React.useState(false)
  const dispatch = useDispatch()

  return (
    <Dialog open={props.open} fullWidth maxWidth='xs' scroll='paper'>
      <DialogTitleWithIconClose
        label={<Trans>ACTION_DONE_DIALOG_TITLE</Trans>}
        handleClose={
          () => {
            props.closeDialog()
            dispatch(moveToColumn({
              movedFromColumn: props.destination.targetBoardIndex,
              movedToColumn: props.source.sourceBoardIndex,
              movedIndex: props.destination.index,
              moveToIndex: props.source.index
            }))
          }
        }
      />
      <DialogContent
        sx={{
          width: '100%',
          boxSizing: 'border-box',
          margin: 0,
          padding: '0 48px 32px 48px',
          overflowY: 'visible'
        }}
      >
        <FormTopLabel><Trans>ACTION_DONE_NAME_LABEL</Trans></FormTopLabel>
        <TextField
          className='text-muted'
          value={props.action.title}
          name='reason'
          variant='outlined'
          fullWidth
          multiline
          disabled
          sx={{
            marginBottom: '24px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              '& fieldset': {
                border: '1px solid #0000008A'
              }
            }
          }}
        />
        <FormTopLabel>
          <Trans>ACTION_PLAN_EXPECTED_OUTCOME_LABEL</Trans>
        </FormTopLabel>
        <TextField
          className='text-muted'
          value={props.action.expectedOutcome}
          name='reason'
          variant='outlined'
          fullWidth
          multiline
          disabled
          sx={{
            marginBottom: '24px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              '& fieldset': {
                border: '1px solid #0000008A'
              }
            }
          }}
        />
        <FormTopLabel><Trans>ACTION_DONE_ACTUAL_OUTCOME_LABEL</Trans></FormTopLabel>
        <TextField
          className='text-muted'
          onChange={event => {
            setActual(event.target.value)
          }}
          value={actual}
          rows={3}
          name='reason'
          variant='outlined'
          fullWidth
          multiline
          sx={{
            marginBottom: '24px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: '0.25px solid rgba(0, 0, 0, 0.54)'
              }
            }
          }}
        />
        <FormTopLabel required>
          <Trans>ACTION_DONE_SUCCESS_LABEL</Trans>
        </FormTopLabel>
        <Slider
          color='primary'
          onChange={(event, newValue) => {
            setSuccess(newValue)
          }}
          onChangeCommitted={() => setSuccessTouched(true)}
          value={success}
          step={1}
          min={1}
          max={5}
          marks={[
            { value: 1, label: '1' },
            { value: 2, label: '2' },
            { value: 3, label: '3' },
            { value: 4, label: '4' },
            { value: 5, label: '5' }
          ]}
          valueLabelDisplay='auto'
          sx={{
            '& .MuiSlider-valueLabel': {
              backgroundColor: 'primary.main'
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: '16px'
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#17374F',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '16px'
              }}
            >
              1&nbsp;&mdash;&nbsp;<Trans>ACTION_DONE_NO_SUCCESS_TEXT</Trans>
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                color: '#17374F',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '16px'
              }}
            >
              5&nbsp;&mdash;&nbsp;<Trans>ACTION_DONE_SUCCESS_TEXT</Trans>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        disableSpacing
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          padding: '0 48px 48px 48px',
          margin: 0,
          alignItems: 'stretch',
          gap: 2
        }}
      >
        <Button
          variant='contained'
          color='primary'
          fullWidth
          disabled={!successTouched}
          onClick={() => {
            props.handleSave(
              {
                ...props.action,
                failReason: null,
                column: 'Done',
                success,
                actualOutcome: actual
              },
              INDEX_OF_DONE,
              props.destination.index,
              props.source.sourceBoardIndex
            )
          }}
        >
          <Trans>Save</Trans>
        </Button>
        <Button
          variant='outlined'
          color='primary'
          fullWidth
          onClick={() => {
            props.closeDialog()
            dispatch(moveToColumn({
              movedFromColumn: props.destination.targetBoardIndex,
              movedToColumn: props.source.sourceBoardIndex,
              movedIndex: props.destination.index,
              moveToIndex: props.source.index
            }))
          }}
        >
          <Trans>Cancel</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActionDoneDialog
